import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const NoDataToDisplayBox = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
